import { Box, Button, Grid } from "@mui/material";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../../../context/AuthContext";
import LectureDto from "../../../../interfaces/lecture/LectureDto";
import Colors from "../../../../utils/Colors";
import Routes from "../../../../utils/Routes";
import { DATE_FORMAT_STYLE, isLectureFuture, isLectureLive, parseStartEndTime } from "../../../../utils/Utils";
import { AddButton } from "../../../shared/components/styledComponents";
import GridCard from "../../../shared/grid-card/GridCard";
import AddIcon from "../../../shared/icons/AddIcon";
import MenuAnon from "../../../shared/menu/MenuAnon";
import MyLecturesService, { MyLecturesServiceType } from "./MyLecturesService";
import FileAdd from "../../../shared/icons/FileAdd";
import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import EnumTabs from "../../../../utils/enum/EnumTabs";

export default function MyLectures() {
  const history = useHistory();
  const { updateSelectedLecture } = useAppContext();
  const { lectures, openMenuLecture, handleOpenMenu, handleCloseMenu, anchorEl, setAnchorEl, sendEmails, isLoading }: MyLecturesServiceType = MyLecturesService();

  const endLecture = lectures.filter((l: LectureDto) => !isLectureLive(l) && !l.isOpenForumLecture);
  const liveLecture = lectures.filter((l: LectureDto) => isLectureLive(l) && !l.isOpenForumLecture);
  const openForumLecture = lectures.filter((l: LectureDto) => l?.isOpenForumLecture);


  const [file, setFile] = useState<any>();
  const sortLectures = (lectureArray: LectureDto[]) => {
    return lectureArray.sort((a: LectureDto, b: LectureDto) => {
      return moment(a.startTime).valueOf() - moment(b.startTime).valueOf();
    });
  }

  const lecturesToDisplay = [...openForumLecture, ...sortLectures([...endLecture, ...liveLecture])];

  const handleFileChange = async (e: any) => {
    const files = e.target.files;
    if (files.length) {
      const file = files[0];
      setFile(file);
    }
  };

  const sendMeetingCodes = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const text = event.target.result;
        sendEmails(text);
      };
      reader.readAsText(file);
    } else {
      alert("Please upload a file containing email addresses.");
    }
  };

  return (
    <div className="my-lectures">
      <div className="lecture-card__subtext">{lectures?.length ? "My Topics" : "There is no topics at this time.  Please create a new topic."}</div>
      <Box sx={{ pb: 2 }}>
        <AddButton startIcon={<AddIcon />} onClick={() => history.push(Routes.TEACHER_MY_LECTURES_ADD)}>
          Add a New Topic
        </AddButton>
      </Box>
      {lectures && lectures?.length > 0 &&
        <Grid container rowSpacing={6} columnSpacing={4} pb={2}>
          <Grid container item xs={12} justifyContent="start" alignItems="center" style={{ marginBottom: "37px" }} rowGap={2} columnGap={2}>
            <Button variant="contained" className="v-btn ac-color-white btn-upload-presentation" component="label">
              <input id="file" type="file" name="file" accept=".csv" hidden onChange={handleFileChange} />
              {file ? file?.name : "Upload emails list"}
              <Grid item ml={2}>
                <FileAdd />
              </Grid>
            </Button>
            <LoadingButton loading={isLoading} disabled={isLoading || !file} loadingPosition="start" component="label" variant="contained" onClick={() => sendMeetingCodes()} className="v-btn ac-color-white btn-send">
              Send meeting codes
            </LoadingButton>
          </Grid>
        </Grid>
      }
      <Grid container justifyContent={{ xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" }} alignItems="flex-start" rowSpacing={1} columnSpacing={1}>
        {lecturesToDisplay.map(({ id, name, startTime, endTime, lectureNum, isOpenForumLecture }: LectureDto, index: number) => {
          const isLive = isLectureLive({ startTime, endTime });
          const isFuture = isLectureFuture({ startTime, endTime });

          return (
            <Grid key={id} item sx={{ color: `${Colors.RED_SOLID} !important` }} style={{ backgroundColor: "green !important" }}>
              <GridCard
                isLive={isLive}
                isFuture={isFuture}
                position={index + 1}
                title={startTime ? moment(startTime).format(DATE_FORMAT_STYLE) : ""}

                cardAction={() => {
                  if (isLive) {
                    history.push(Routes.TEACHER_CLASS_STATUS)
                  } else {
                    updateSelectedLecture({ id, name, lectureNum });
                    history.push(Routes.TEACHER_QUESTIONS.replace(":lectureNum", String(lectureNum)));
                  }
                }
                }
                subtitle={parseStartEndTime(startTime, endTime)}
                headerAction={(event: any) => {
                  event.stopPropagation();
                  setAnchorEl(event.currentTarget);
                  handleOpenMenu(id);
                }}
                showDots={true}
                name={name}
                active={false}
                color={isFuture ? Colors.LECTURE_FUTURE : isLive ? Colors.LECTURE_LIVE : Colors.LECTURE_LIVE}
                isOpenForum={isOpenForumLecture}
              />
              <MenuAnon
                anchorEl={anchorEl}
                id={`menu-${name}`}
                open={openMenuLecture === id}
                handleClose={handleCloseMenu}
                items={[
                  {
                    label: "Live questions",
                    action: () => history.push(Routes.TEACHER_QUESTIONS.replace(":lectureNum", String(lectureNum))),
                  },
                  {
                    label: "Statistics",
                    action: () => history.push(Routes.LECTURE_STATS.replace(":lectureNum", String(lectureNum))),
                  },
                  {
                    label: "My questions",
                    action: () =>
                      history.push({
                        pathname: Routes.TEACHER_MY_QUESTIONS,
                        state: { initLectureId: id },
                      }),
                  },
                  {
                    label: "My answers",
                    action: () =>
                      history.push({
                        pathname: Routes.TEACHER_MY_ANSWERS,
                        state: { initLectureId: id },
                      }),
                  },
                  {
                    label: "Edit",
                    action: () => {
                      updateSelectedLecture({ id, name, lectureNum });
                      history.push(`${Routes.TEACHER_MY_LECTURES}/edit/${lectureNum}`);
                    },
                  },
                ]}
              />
            </Grid>
          );
        })}
        {lectures && lectures?.length / 2 !== 0 && <Grid container className="lecture-card__fake-card" item></Grid>}
      </Grid>
    </div >
  );
}
